/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, name: NonNullable<unknown> }} Plan_Session_NameInputs */

const en_us2_plan_session_name = /** @type {(inputs: Plan_Session_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workout ${i?.label} · ${i?.name}`)
};

const pt_br2_plan_session_name = /** @type {(inputs: Plan_Session_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino ${i?.label} · ${i?.name}`)
};

const es_419_plan_session_name = /** @type {(inputs: Plan_Session_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entrenamiento ${i?.label} · ${i?.name}`)
};

const pt_pt2_plan_session_name = /** @type {(inputs: Plan_Session_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino ${i?.label} · ${i?.name}`)
};

const fr_fr2_plan_session_name = /** @type {(inputs: Plan_Session_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séance ${i?.label} · ${i?.name}`)
};

const de_de2_plan_session_name = /** @type {(inputs: Plan_Session_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Training ${i?.label} · ${i?.name}`)
};

const it_it2_plan_session_name = /** @type {(inputs: Plan_Session_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Allenamento ${i?.label} · ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Workout {label} · {name}" |
*
* @param {Plan_Session_NameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_session_name = /** @type {((inputs: Plan_Session_NameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Session_NameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_session_name(inputs)
	if (locale === "es-419") return es_419_plan_session_name(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_session_name(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_session_name(inputs)
	if (locale === "de-DE") return de_de2_plan_session_name(inputs)
	if (locale === "it-IT") return it_it2_plan_session_name(inputs)
	return en_us2_plan_session_name(inputs)
});
export { plan_session_name as "plan.session_name" }